'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = require('redux');

var _reduxThunk = require('redux-thunk');

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _reducers = require('pricing-pages-unified-ui/reducers');

var _reducers2 = _interopRequireDefault(_reducers);

var _sentryMiddleware = require('pricing-pages-unified-ui/utils/sentryMiddleware');

var _sentryMiddleware2 = _interopRequireDefault(_sentryMiddleware);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//const middleware = [thunk, routerMiddleware(browserHistory)];
var middleware = [_reduxThunk2.default, _sentryMiddleware2.default];
//import { routerMiddleware } from 'react-router-redux';


var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || _redux.compose;

var createStoreWithMiddleware = composeEnhancers(_redux.applyMiddleware.apply(undefined, middleware))(_redux.createStore);

var initialState = {};
var store = createStoreWithMiddleware(_reducers2.default, initialState);

exports.default = store;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/utils/store.js
// module id = 224
// module chunks = 3 4 5